<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-transfer-dialog">
  <gb-event-ticket-guest-stepper
    [config]="{
      title: 'SHARED.EVENT_TICKETS.TRANSFER_TICKET.HEADER',
      buttonLabel: 'SHARED.EVENT_TICKETS.TRANSFER_TICKET.TRANSFER_BUTTON',
      skipLinkLabel: 'SHARED.EVENT_TICKETS.TRANSFER_TICKET.SKIP_LINK',
      shouldPrepopulateForm: false,
      shouldShowSelfAssign: eventTicket.profile?.uuid !== eventTicket.purchaser.uuid,
    }"
    (onSubmitEvent)="onSubmit($event)"
  >
    <p translate="SHARED.EVENT_TICKETS.TRANSFER_TICKET.DESCRIPTION"></p>
    <p
      [innerHtml]="
        'SHARED.EVENT_TICKETS.TRANSFER_TICKET.ON_TRANSFER_INFO' | translate: { email: eventTicket.profile?.email }
      "
    ></p>
  </gb-event-ticket-guest-stepper>
</div>
